var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { i18n } from '@easydata/core';
import { utils as dataUtils } from '@easydata/core';
import { equtils, QueryChangeAction } from '@easyquery/core';
import { createBrowserEvent, domel } from '@easydata/ui';
import { TextRenderer } from './text_renderer';
import { browserUtils } from '../../../utils/browser_utils';
import { QPEditablePart } from '../../../types/qp_editable_part';
export var ConditionAction;
(function (ConditionAction) {
    ConditionAction[ConditionAction["AddCondition"] = 0] = "AddCondition";
    ConditionAction[ConditionAction["AddGroup"] = 1] = "AddGroup";
    ConditionAction[ConditionAction["Enable"] = 2] = "Enable";
    ConditionAction[ConditionAction["Delete"] = 4] = "Delete";
    ConditionAction[ConditionAction["Menu"] = 5] = "Menu";
    ConditionAction[ConditionAction["Parameterized"] = 6] = "Parameterized";
    ConditionAction[ConditionAction["InJoin"] = 7] = "InJoin";
})(ConditionAction || (ConditionAction = {}));
var ConditionRenderer = /** @class */ (function () {
    function ConditionRenderer(panel, condition, slot) {
        this.panel = panel;
        this.condition = condition;
        this.element = slot || domel('div').toDOM();
    }
    Object.defineProperty(ConditionRenderer.prototype, "cssPrefix", {
        get: function () {
            return 'eqjs-qp';
        },
        enumerable: true,
        configurable: true
    });
    ConditionRenderer.prototype.refresh = function () {
        this.render();
    };
    ConditionRenderer.prototype.clear = function () {
        if (this.element) {
            this.element.className = '';
            this.element.removeAttribute('data-id');
            this.element.removeAttribute('style');
            domel(this.element)
                .html('');
        }
    };
    ConditionRenderer.prototype.render = function (autoAppear) {
        this.clear();
        //this.preRender();
        this.coreRender(autoAppear);
        if (this.panel.options.onConditionRendered) {
            this.panel.options.onConditionRendered(this.condition, this.element);
        }
        return this.element;
    };
    ConditionRenderer.prototype.isEditable = function () {
        return this.condition.enabled && !this.condition.isReadOnly();
    };
    return ConditionRenderer;
}());
export { ConditionRenderer };
var SimpleConditionRenderer = /** @class */ (function (_super) {
    __extends(SimpleConditionRenderer, _super);
    function SimpleConditionRenderer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SimpleConditionRenderer.prototype.getClassesToAdd = function () {
        var result = this.cssPrefix + "-row " + this.cssPrefix + "-row-condition";
        result += this.condition.isInJoin() ? " " + this.cssPrefix + "-condition-injoin" : '';
        result += this.condition.isParameterized() ? " " + this.cssPrefix + "-condition-parameterized" : '';
        if (!browserUtils.isMobileMode()) {
            var level = this.condition.getLevel();
            if (level > 0)
                result += " " + this.cssPrefix + "-level-" + level;
        }
        result += this.condition.enabled ? '' : " " + this.cssPrefix + "-disabled";
        if (this.condition.enabled) {
            result += this.condition.isReadOnly() ? " " + this.cssPrefix + "-readonly" : '';
        }
        return result;
    };
    SimpleConditionRenderer.prototype.coreRender = function (autoAppear) {
        var _this = this;
        var model = this.panel.getContext().getModel();
        var operator = model.getOperatorById(this.condition.getOperatorId());
        var arrFormat = equtils.parseOperatorFormat(operator);
        var item = null;
        var arrLength = arrFormat.length;
        var builder = domel('div');
        if (this.element && this.element.parentNode) {
            this.element.parentNode
                .replaceChild(builder.toDOM(), this.element);
        }
        this.element = builder.toDOM();
        builder
            .addClass(this.getClassesToAdd())
            .addClass(browserUtils.getMobileCssClass())
            .data('id', this.condition.id)
            .data('condrow', '')
            .addChildElement(this.renderCheckbox())
            .addChildElement(this.renderConjunction());
        var mayAppear = autoAppear;
        var minLength = operator == model.nullOperator
            ? Math.min(arrLength, this.condition.expressions.length + 1)
            : arrLength;
        var _loop_1 = function (idx) {
            item = arrFormat[idx];
            if (item.type === 'operator') {
                var renderer = this_1.panel.getOperatorRenderer(this_1.condition, item.text);
                if (renderer) {
                    builder.addChildElement(renderer.render());
                }
            }
            else if (item.type === 'expression') {
                var toAppear = mayAppear && (item.index > 0);
                var exprRenderer_1 = this_1.panel.getExpressionRenderer(this_1.condition.expressions[item.index]);
                if (exprRenderer_1) {
                    var el = exprRenderer_1.render(toAppear);
                    builder.addChildElement(el);
                    setTimeout(function () {
                        exprRenderer_1.adjustWidth();
                    }, 100);
                }
                mayAppear = mayAppear && !toAppear;
            }
            else if (item.type === 'text') {
                builder.addChildElement(new TextRenderer(this_1.panel, item.text).render());
            }
        };
        var this_1 = this;
        for (var idx = 0; idx < minLength; idx++) {
            _loop_1(idx);
        }
        if (this.panel.options.accentActiveCondition || browserUtils.isMobileMode()) {
            builder.on('click', function (ev) {
                ev.stopPropagation();
                _this.panel.toggleConditionPicked(_this.condition);
                _this.adjustButtonsVisibility();
                if (!browserUtils.isMobileMode()) {
                    _this.element.dispatchEvent(createBrowserEvent("mouseenter"));
                }
                return false;
            });
        }
        builder
            .addChildElement(this.renderButtonsBlock());
        if (!browserUtils.isMobileMode()) {
            builder
                .on('mouseenter', function (event) {
                _this.isMouseOverBlock = true;
                _this.enterButtonBlock();
                event.stopPropagation();
                return false;
            })
                .on('mouseleave', function (event) {
                _this.isMouseOverBlock = false;
                if (!_this.keepShowingButtons && domel(_this.buttonsBlock).isVisible()) {
                    _this.leaveButtonBlock();
                }
                event.stopPropagation();
                return false;
            });
        }
    };
    SimpleConditionRenderer.prototype.setConditionParameterized = function (value) {
        this.condition.setParameterized(value);
        this.condition.fireChangedEvent();
    };
    SimpleConditionRenderer.prototype.setConditionInJoin = function (value) {
        this.condition.setInJoin(value);
        this.condition.fireChangedEvent();
    };
    SimpleConditionRenderer.prototype.getConditionMenu = function () {
        return this.panel.getConditionMenu();
    };
    SimpleConditionRenderer.prototype.renderConjunction = function () {
        var parent = this.condition.getParent();
        if (!parent)
            return null;
        var isFirstConditionInGroup = dataUtils.findItemIndexById(parent.getConditions(), this.condition.id) == 0;
        if (this.panel.options.showConjunctions && !isFirstConditionInGroup) {
            var linkTypeStr = equtils.linkTypeToStr(this.condition.getParent().linkType);
            var conjuctionText = i18n.getText("Conj" + linkTypeStr);
            return domel("span")
                .text(conjuctionText)
                .title(conjuctionText)
                .addClass(this.cssPrefix + "-condelement " + this.cssPrefix + "-condition-conjuction")
                .toDOM();
        }
        return null;
    };
    SimpleConditionRenderer.prototype.renderCheckbox = function () {
        var _this = this;
        if (this.panel.options.showCheckboxes && !this.condition.isReadOnly()) {
            return domel("div")
                .title(i18n.getText('CmdToggleEnable'))
                .attr('tabIndex', '0')
                .addClass(this.cssPrefix + "-condelement " + this.cssPrefix + "-condition-checkbox")
                .addClass("" + (this.condition.enabled ? 'enabled' : ''))
                .on('click', function () {
                _this.condition.enabled = !_this.condition.enabled;
                _this.condition.fireChangedEvent();
                return false;
            })
                .on('keypress', function (evt) { if ([13, 32].includes(evt.keyCode)) {
                evt.target.click();
            } })
                .toDOM();
        }
        else {
            return null;
        }
    };
    SimpleConditionRenderer.prototype.isConditionActive = function () {
        return this.element.classList.contains("active");
    };
    SimpleConditionRenderer.prototype.hideButtons = function () {
        domel(this.element).data("show-buttons", null);
    };
    SimpleConditionRenderer.prototype.showButtons = function () {
        domel(this.element).data("show-buttons", "");
    };
    SimpleConditionRenderer.prototype.adjustButtonsVisibility = function () {
        if (this.panel.options.alwaysShowButtonsInConditions
            || (this.panel.options.accentActiveCondition && this.isConditionActive())) {
            this.showButtons();
        }
    };
    SimpleConditionRenderer.prototype.enterButtonBlock = function () {
        this.showButtons();
    };
    SimpleConditionRenderer.prototype.leaveButtonBlock = function () {
        if (!this.panel.options.alwaysShowButtonsInConditions
            && (!this.isConditionActive() || !this.panel.options.accentActiveCondition)) {
            this.hideButtons();
        }
    };
    SimpleConditionRenderer.prototype.conditionMenuHandler = function (action, evt) {
        var _this = this;
        switch (action) {
            case ConditionAction.AddCondition:
                if (!this.condition.isGroup())
                    return;
                var entMenu = this.panel.getEntitiesMenu();
                if (entMenu) {
                    entMenu.showMenu({
                        anchor: evt.target,
                        itemSelectedCallback: function (item) {
                            var query = _this.panel.getQuery();
                            var descr = {
                                parent: _this.condition,
                                attributeId: item.id
                            };
                            var cond = query.addSimpleCondition(descr);
                            if (cond) {
                                query.fireConditionsChangedEvent(QueryChangeAction.Add, cond);
                            }
                            return false;
                        }
                    });
                }
                break;
            case ConditionAction.AddGroup:
                if (!this.condition.isGroup())
                    return;
                var query = this.panel.getQuery();
                var descr = {
                    parent: this.condition
                };
                var group = this.panel.getQuery().addConditionGroup(descr);
                if (group) {
                    query.fireConditionsChangedEvent(QueryChangeAction.Add, group);
                }
                break;
            case ConditionAction.Enable:
                this.condition.enabled = !this.condition.enabled;
                this.condition.fireChangedEvent();
                break;
            case ConditionAction.Delete:
                var parent_1 = this.condition.getParent();
                if (!parent_1)
                    return;
                var conditions = parent_1.getConditions();
                var idx = conditions.indexOf(this.condition);
                if (idx >= 0) {
                    conditions.splice(idx, 1);
                    this.condition.getQuery().fireConditionsChangedEvent(QueryChangeAction.Delete, this.condition);
                }
                break;
            case ConditionAction.Menu:
                var condMenu = this.getConditionMenu();
                this.keepShowingButtons = true;
                condMenu.showMenu({
                    anchor: evt.target,
                    selectedIds: this.getConditionMenuSelectedItems(),
                    itemSelectedCallback: function (item) {
                        var action;
                        switch (item.id) {
                            case "enable":
                                action = ConditionAction.Enable;
                                break;
                            case "delete":
                                action = ConditionAction.Delete;
                                break;
                            case "param":
                                action = ConditionAction.Parameterized;
                                break;
                            case "inJoin":
                                action = ConditionAction.InJoin;
                                break;
                            case "addCondition":
                                action = ConditionAction.AddCondition;
                                break;
                            case "addGroup":
                                action = ConditionAction.AddGroup;
                                break;
                        }
                        _this.conditionMenuHandler(action, evt);
                    },
                    itemFilterCallback: function (item) {
                        var result = _this.condition.enabled || item.id === "enable" || item.id === "delete";
                        if (item.id === "enable") {
                            var parent_2 = _this.condition.getParent();
                            result = result && parent_2 && parent_2.enabled;
                        }
                        else if (item.id === "delete") {
                            result = result && ((_this.panel.options.editableParts & QPEditablePart.Removal) === QPEditablePart.Removal);
                        }
                        else if (item.id === "addGroup" || item.id === "addCondition") {
                            result = result && ((_this.panel.options.editableParts & QPEditablePart.Addition) === QPEditablePart.Addition);
                        }
                        return result;
                    },
                    menuClosedCallback: function () {
                        _this.keepShowingButtons = false;
                        if (!_this.isMouseOverBlock)
                            _this.leaveButtonBlock();
                    }
                });
                break;
            case ConditionAction.Parameterized:
                this.condition.setParameterized(!this.condition.isParameterized());
                this.condition.fireChangedEvent();
                break;
            case ConditionAction.InJoin:
                this.condition.setInJoin(!this.condition.isInJoin());
                this.condition.fireChangedEvent();
                break;
        }
        evt.stopPropagation();
        return false;
    };
    SimpleConditionRenderer.prototype.getConditionMenuSelectedItems = function () {
        var arrSelected = [];
        if (this.condition.enabled) {
            arrSelected.push("enable");
        }
        ;
        if (this.condition.isParameterized()) {
            arrSelected.push("param");
        }
        ;
        if (this.condition.isInJoin()) {
            arrSelected.push("inJoin");
        }
        ;
        return arrSelected;
    };
    SimpleConditionRenderer.prototype.renderButtonsBlock = function () {
        var _this = this;
        var onButtonMouseEnter = function (evt) {
            domel(evt.target)
                .addClass(_this.cssPrefix + "-condition-button-active");
        };
        var onButtonMouseLeave = function (evt) {
            domel(evt.target)
                .removeClass(_this.cssPrefix + "-condition-button-active");
        };
        var builder = domel("div")
            .addClass(this.cssPrefix + "-condition-buttonsBlock")
            .addClass(browserUtils.getMobileCssClass());
        this.buttonsBlock = builder.toDOM();
        if (this.condition.isReadOnly()) {
            return this.buttonsBlock;
        }
        var buttonsToShow = this.getButtonsToShow();
        if (buttonsToShow.indexOf("addCondition") >= 0 && this.condition.enabled
            && ((this.panel.options.editableParts & QPEditablePart.Addition) == QPEditablePart.Addition)) {
            builder.addChild("div", function (b) {
                b.addClass(_this.cssPrefix + "-button-placeholder")
                    .data("btnplaceholder", "")
                    .addChild("div", function (b) {
                    b.addClass(_this.cssPrefix + "-condition-button " + _this.cssPrefix + "-condition-button-addCondition")
                        .attr('tabIndex', '0')
                        .data("button", "")
                        .title(i18n.getText('CmdAddCondition'))
                        .on('click', function (evt) { return _this.conditionMenuHandler(ConditionAction.AddCondition, evt); })
                        .on('keypress', function (evt) { if (evt.keyCode == 13) {
                        evt.target.click();
                    } })
                        .on('mouseenter', onButtonMouseEnter)
                        .on('mouseleave', onButtonMouseLeave);
                });
            });
        }
        ;
        var showAddGroupBtn = buttonsToShow.indexOf("addGroup") >= 0 || buttonsToShow.indexOf("addPredicate") >= 0;
        if (showAddGroupBtn && this.condition.enabled
            && ((this.panel.options.editableParts & QPEditablePart.Addition) == QPEditablePart.Addition)) {
            builder.addChild("div", function (b) {
                b.addClass(_this.cssPrefix + "-button-placeholder")
                    .data("btnplaceholder", "")
                    .addChild("div", function (b) {
                    b.addClass(_this.cssPrefix + "-condition-button " + _this.cssPrefix + "-condition-button-addPredicate")
                        .attr('tabIndex', '0')
                        .data("button", "")
                        .title(i18n.getText('CmdAddCondGroup'))
                        .on('click', function (evt) { return _this.conditionMenuHandler(ConditionAction.AddGroup, evt); })
                        .on('keypress', function (evt) { if (evt.keyCode == 13) {
                        evt.target.click();
                    } })
                        .on('mouseenter', onButtonMouseEnter)
                        .on('mouseleave', onButtonMouseLeave);
                });
            });
        }
        ;
        if (this.getButtonsToShow().indexOf("enable") >= 0 && this.condition.getParent() && this.condition.getParent().enabled) {
            builder.addChild("div", function (b) {
                b.addClass(_this.cssPrefix + "-button-placeholder")
                    .data("btnplaceholder", "")
                    .addChild("div", function (b) {
                    b.addClass(_this.cssPrefix + "-condition-button " + _this.cssPrefix + "-condition-button-enable")
                        .attr('tabIndex', '0')
                        .data("button", "")
                        .title(i18n.getText('CmdToggleEnable'))
                        .addClass(_this.condition.enabled ? 'enabled' : '')
                        .on('click', function (evt) { return _this.conditionMenuHandler(ConditionAction.Enable, evt); })
                        .on('keypress', function (evt) { if (evt.keyCode == 13) {
                        evt.target.click();
                    } })
                        .on('mouseenter', onButtonMouseEnter)
                        .on('mouseleave', onButtonMouseLeave);
                });
            });
        }
        ;
        if (this.getButtonsToShow().indexOf("delete") >= 0 && this.condition.getParent()
            && ((this.panel.options.editableParts & QPEditablePart.Removal) == QPEditablePart.Removal)) {
            builder.addChild("div", function (b) {
                b.addClass(_this.cssPrefix + "-button-placeholder")
                    .data("btnplaceholder", "")
                    .addChild("div", function (b) {
                    b.addClass(_this.cssPrefix + "-condition-button " + _this.cssPrefix + "-condition-button-delete")
                        .attr('tabIndex', '0')
                        .data("button", "")
                        .title(i18n.getText('CmdDelete'))
                        .on('click', function (evt) { return _this.conditionMenuHandler(ConditionAction.Delete, evt); })
                        .on('keypress', function (evt) { if (evt.keyCode == 13) {
                        evt.target.click();
                    } })
                        .on('mouseenter', onButtonMouseEnter)
                        .on('mouseleave', onButtonMouseLeave);
                });
            });
        }
        ;
        if (this.getButtonsToShow().indexOf("menu") >= 0) {
            builder.addChild("div", function (b) {
                b.addClass(_this.cssPrefix + "-button-placeholder")
                    .data("btnplaceholder", "")
                    .addChild("div", function (b) {
                    b.addClass(_this.cssPrefix + "-condition-button " + _this.cssPrefix + "-condition-button-menu")
                        .attr('tabIndex', '0')
                        .data("button", "")
                        .title(i18n.getText('ButtonMenu'))
                        .on('click', function (evt) { return _this.conditionMenuHandler(ConditionAction.Menu, evt); });
                    if (!browserUtils.isMobileMode()) {
                        b
                            .on('keypress', function (evt) { if (evt.keyCode == 13) {
                            evt.target.click();
                        } })
                            .on('mouseenter', onButtonMouseEnter)
                            .on('mouseleave', onButtonMouseLeave);
                    }
                });
            });
        }
        ;
        this.adjustButtonsVisibility();
        return this.buttonsBlock;
    };
    SimpleConditionRenderer.prototype.getButtonsToShow = function () {
        return this.panel.options.buttons && this.panel.options.buttons.condition && Array.isArray(this.panel.options.buttons.condition) ? this.panel.options.buttons.condition : ["enable", "delete"];
    };
    return SimpleConditionRenderer;
}(ConditionRenderer));
export { SimpleConditionRenderer };
//# sourceMappingURL=condition_renderer.js.map